import classNames from 'classnames/bind';
import Icon, { IconVariant } from 'src/components/ui-kit/icon/icon';
import styles from './form.module.scss';
import FormError from './_error';
import { FormTextInputProps, getError, getValue, onBlur } from './_text-input';
import { IMaskInput } from 'react-imask';

const classesContext = classNames.bind(styles);

export default function FormTextInputPhone<T>({
  formik,
  name,
  isAsteriskShown,
  isBordered,
  isLockShown,
  className,
  ...inputProps
}: FormTextInputProps<T>): JSX.Element {
  const error = getError<T>(formik, name);

  const onAccept = <T,>(value: T): void => {
    if (name) {
      return formik?.setFieldValue(name, value);
    }
  };

  return (
    <div
      className={classesContext([
        'form_group',
        {
          form_group__required: isAsteriskShown,
          form_group__bordered: isBordered,
          form_group__error: error
        },
        className
      ])}
    >
      <IMaskInput
        mask='000-000-0000'
        onChange={formik?.handleChange}
        onBlur={() => onBlur(formik, name)}
        name={name}
        value={getValue<T>(formik, name) as any}
        type='phone'
        onAccept={onAccept}
        className={styles.form_control}
        {...inputProps}
      />
      {isLockShown && (
        <span className={styles.form_group__disabled}>
          <Icon variant={IconVariant.LOCK} />
        </span>
      )}
      {error && <FormError error={error} />}
    </div>
  );
}
